import { render, staticRenderFns } from "./ReceiptOverviewFilter.vue?vue&type=template&id=2dd807a0&"
import script from "./ReceiptOverviewFilter.vue?vue&type=script&lang=ts&"
export * from "./ReceiptOverviewFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports